import session_jfrp from './session/jfrp'
import session_skey from './session/skey'
import session_pskey from './session/pskey'
import session_wechat from './session/wechat'
import session_qqconnect from './session/qqconnect'

export default function (sessionParam) {
  let openid = decodeURIComponent(sessionParam.openid)
  let openkey = decodeURIComponent(sessionParam.openkey)
  let sessionid = sessionParam.session_id
  let sessiontype = sessionParam.session_type
  let wxAppid2 = sessionParam.wx_appid
  let qq_appid = sessionParam.qq_appid || ''

  if (sessionid === 'jfrp_id' && sessiontype === 'jfrp_key') {
    return new session_jfrp({
      openid: openid,
      openkey: openkey
    })
  } else if (sessionid === 'uin' && sessiontype === 'skey') {
    return new session_skey({
      uin: openid,
      skey: openkey
    })
  } else if (sessionid === 'uin' && sessiontype.indexOf('pskey_') === 0) {
    return new session_pskey({
      uin: openid,
      pskey: openkey,
      sessiontype: sessiontype
    })
  } else if (sessionid === 'hy_gameid' && sessiontype === 'wc_actoken') {
    return new session_wechat({
      openid,
      accessToken: openkey,
      appid: wxAppid2
    })
  } else if (sessionid === 'openid' && sessiontype === 'kp_actoken') {
    // QQ互联登录态
    return new session_qqconnect({
      openid,
      payToken: openkey,
      qq_appid
    })
  } else if (location.protocol === 'https:' && sessionid === 'openid' && sessiontype === 'kp_accesstoken') {
    // QQ互联登录态accesstoken方式只允许在https模式下使用
    return new session_qqconnect({
      openid,
      accessToken: openkey,
      qq_appid
    })
  }
  return null
}
